<template>
    <section class="section">
        <div class="container is-max-widescreen is-max-desktop">
            <h1 class="title has-text-centered">
                État des validations
            </h1>
            <hr>
            <p><b>Légende</b></p>
            <ul>
                <li><span style="background-color: green; color: white">Validée</span></li>
                <li><span style="background-color: orange; color: white">En attente de validation</span></li>
                <li><span style="background-color: red; color: white">Refusée</span></li>
                <li><span style="background-color: grey; color: white">Brouillon</span></li>
                <li><span>Si pas de couleur = pas de feuille de temps initialisée</span></li>
            </ul>

            <hr>
            <b-field grouped>
                <b-field label="Année">
                    <b-select
                        placeholder="Sélectionner"
                        v-model="annee"
                        @input="filterYear()"
                    >
                        <option>2023</option>
                        <option>2024</option>
                        <option>2025</option>
                        <option>2026</option>
                    </b-select>
                </b-field>

                <b-field label="Service / antenne">
                    <b-select placeholder="Sélectionner"
                              v-model="service"
                              @input="filterService()"
                    >
                        <option
                            v-for="s in services"
                            :value="s"
                            :key="s">
                            {{ s }}
                        </option>
                    </b-select>
                </b-field>

                <b-field label="Manager">
                    <b-select placeholder="Sélectionner"
                              v-model="manager"
                              @input="filterManager()">
                        <option
                            v-for="m in managers"
                            :value="m"
                            :key="m">
                            {{ m }}
                        </option>
                    </b-select>
                </b-field>
                <b-field>
                    <b-switch v-model="hSup">
                        Afficher les heures sup (debug)
                    </b-switch>
                </b-field>
            </b-field>


            <table id="uglytable">

                <thead>
                <tr>
                    <th style="width: 10%">Service / antenne</th>
                    <th style="width: 10%">Manager</th>
                    <th style="width: 10%">Salarié</th>
                    <th v-if="hSup">H.Sup</th>
                    <th v-for="week in weeks" :key="week"
                        style="writing-mode: vertical-rl; transform: rotate(180deg); white-space: nowrap;">
                        {{ week }}
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(employeeData, employeeName) in filterTable" :key="employeeName" style="font-size: small">
                    <td>{{
                            employeeData[0].info && employeeData[0].info.info && employeeData[0].info.info.companyDepartment ? employeeData[0].info.info.companyDepartment.name : (employeeData[0].service || "???")
                        }}
                    </td>
                    <td>{{ employeeData[0].info && employeeData[0].info.managerUser ? employeeData[0].info.managerUser.fullName : (employeeData[0].manager || "???") }}</td>
                    <td>{{ employeeData[0].info && employeeData[0].info.user ? employeeData[0].info.user.fullName : (employeeData[0].employee ? employeeData[0].employee.name : employeeName) }}</td>
                    <td v-if="hSup"> {{ hsSum(employeeData) }} h</td>

                    <td v-for="week in weeks" :key="week" :style="getCellStyle(employeeData, week)">
                        <span style="background-color: white" v-if="hSup">{{ getHeuresSup(employeeData, week) }}</span>
                    </td>
                </tr>
                </tbody>

            </table>

        </div>
    </section>
</template>

<script>

export default {
    name: "WeekTimesheet",
    components: {},
    mounted() {
        this.makeGantt();
    },
    computed: {},
    methods: {
        async makeGantt(y = 2025) {
            const loadingComponent = this.$buefy.loading.open({
                container: null
            })
            try {
                const r = await this.$axios.get(`weektimesheet?year=${y}`);
                this.employeeData = r.data;
                this.filterTable = r.data;

                let uniqueValues = new Set();
                Object.values(r.data).forEach(dictionaries => {
                    dictionaries.forEach(d => {
                        uniqueValues.add(d['week']);
                    });
                });
                this.weeks = Array.from(uniqueValues)
                .slice()
                .sort((a, b) => {
                    const [yearA, weekA] = a.split('-').map(Number);
                    const [yearB, weekB] = b.split('-').map(Number);

                    // Compare years first
                    if (yearA !== yearB) {
                        return yearA - yearB;
                    }

                    // If years are the same, compare weeks
                    return weekA - weekB;
                });

                uniqueValues = new Set();
                Object.values(r.data).forEach(dictionaries => {
                    dictionaries.forEach(d => {
                        uniqueValues.add(d['manager']);
                    });
                });
                this.managers = Array.from(uniqueValues).slice().sort((a, b) => a.localeCompare(b));

                uniqueValues = new Set();
                Object.values(r.data).forEach(dictionaries => {
                    dictionaries.forEach(d => {
                        uniqueValues.add(d['service']);
                    });
                });
                this.services = Array.from(uniqueValues).slice().sort((a, b) => a.localeCompare(b));
                loadingComponent.close()

            } catch (err) {
                loadingComponent.close()
                console.log(err)
            }
        },

        async filterYear() {
            await this.makeGantt(this.annee)
        },

        filterService() {
            const filteredData = {};
            Object.entries(this.employeeData).forEach(([key, dictionaries]) => {
                const hasMatchingValue = dictionaries.some(d => d['service'] === this.service);
                if (hasMatchingValue) {
                    filteredData[key] = dictionaries;
                }
            });
            this.filterTable = filteredData
            this.manager = ''
        },

        filterManager() {
            const filteredData = {};
            Object.entries(this.employeeData).forEach(([key, dictionaries]) => {
                const hasMatchingValue = dictionaries.some(d => d['manager'] === this.manager);
                if (hasMatchingValue) {
                    filteredData[key] = dictionaries;
                }
            });
            this.filterTable = filteredData
            this.service = ''
        },

        getCellStyle(employeeData, week) {
            // Function to determine cell color based on status
            const employeeWeeks = employeeData.filter(data => data.week === week);
            if (employeeWeeks.length > 0) {
                // Use the statusSelect property to determine the color
                const status = employeeWeeks[0].statusSelect;
                if (status === 1) {
                    return {backgroundColor: 'grey'}; // Example color for a specific status
                } else if (status === 2) {
                    return {backgroundColor: 'orange'}; // Another example color for a different status
                } else if (status === 3) {
                    return {backgroundColor: 'green'}; // Another example color for a different status
                } else if (status === 4) {
                    return {backgroundColor: 'red'}; // Another example color for a different status
                }
            }
            return {}; // Default style if status is not found or doesn't match any condition
        },
        getHeuresSup(employeeData, week) {
            const employeeWeeks = employeeData.filter(data => data.week === week);
            if (employeeWeeks.length > 0) {
                const h = parseFloat(employeeWeeks[0].cenPeriodTotalRestHoursAcquired);
                if (h === null) {
                    return '';
                } else if (h === undefined) {
                    return '';
                } else if (h > 0) {
                    return h;
                }
            }
            return '';
        },
        hsSum(employeeData) {
            let sum = 0
            employeeData.forEach(w => {
                let h = parseFloat(w.cenPeriodTotalRestHoursAcquired);
                if (h > 0) {
                    sum += h;
                }
            })
            return sum.toFixed(2);
        }
    },
    data() {
        return {
            hSup: false,
            employeeData: {},
            filterTable: {},
            weeks: Array.from({length: 53}, (_, index) => index + 1), // Init with 53 columns
            managers: [],
            manager: '',
            services: [],
            service: '',
            annee: 2025
        }
    }
}

</script>

<style scoped>

.container {
    max-width: 100%;
    padding-left: 0%;
    padding-right: 0%;
}

table {
    border-collapse: collapse;
    width: 100%;
}

table, th, td {
    border: 0.5px solid black;
    padding: 1px;
}

tr:nth-child(even) {
    background-color: rgba(177, 157, 227, 0.25);
}

</style>
